<div
	class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop sumax-footer"
	id="kt_footer">
	<div class="kt-container" [ngClass]="{ 'kt-container--fluid': fluid }">
		<div class="kt-footer__copyright">
			{{ today | date : 'yyyy' }}&nbsp;&copy;&nbsp;<a
				href="https://www.sintad.pe"
				target="_blank"
				class="kt-link"
				>Sintad</a
			>
		</div>
		<div class="kt-footer__menu">
			@if (tbTipoCambio$ | async; as tbTipoCambio) {
			<div class="kt-footer__menu">
				{{ tbTipoCambio.fchCambio ?? today | date : 'dd/MM/yyyy' }}
			</div>
			<div class="kt-footer__menu">
				Valor:<strong class="kt-footer__value"
					>&nbsp;{{ tbTipoCambio.tbMoneda?.codigo ?? searchTbTipoCambioDto.codMoneda }}</strong
				>
			</div>
			<div class="kt-footer__menu">
				Compra:<span class="kt-footer__value"
					>&nbsp;{{ tbTipoCambio.valorCompra ?? 0 | number : '1.4-4' }}</span
				>
			</div>
			<div class="kt-footer__menu">
				Venta:
				<span class="kt-footer__value"
					>&nbsp;{{ tbTipoCambio.valorVenta ?? 0 | number : '1.4-4' }}</span
				>
			</div>
			}
			<a
				href="https://www.sintad.pe/contacto"
				class="kt-footer__menu-link kt-link"
				target="_blank"
				rel="noopener noreferrer"
				>Contáctanos</a
			>
		</div>
	</div>
</div>
